<template>
  <div
    class="code"
    :class="isCountDownShow ? 'counting-down' : 'not-count-dowm'"
  >
    <div class="code-text" v-if="!isCountDownShow">获取验证码</div>
    <div class="code-countdown" v-else>{{ countDown }}s后获取</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isCountDownShow: false,
      countDown: 0,
    };
  },
  props: {
    duration: {
      type: Number,
      default: 10,
    },
    localName: {
      type: String,
      require: true,
    },
  },
  created() {
    this.getLocalCountDown();
  },
  methods: {
    //开始倒计时
    getCode() {
      if (this.isCountDownShow) {
        return;
      }
      this.setLocalCountDown().then((localCountDown) => {
        let dateNow = Date.parse(new Date());
        this.countDown = (localCountDown - dateNow) / 1000;
        this.isCountDownShow = true;
        this.calculationCountDown(localCountDown);
      });
    },
    //将当前时间加倒计时时长后存储在本地
    setLocalCountDown() {
      return new Promise((resolve, reject) => {
        let dateNow = Date.parse(new Date());
        let localCountDown = dateNow + this.duration * 1000;
        localStorage.setItem(this.localName, localCountDown);
        resolve(localCountDown);
      });
    },
    //获取本地倒计时，如果没有则不显示倒计时，如果有则判断时间并显示
    getLocalCountDown() {
      let localCountDown = localStorage.getItem(this.localName);
      //判断本地有无localCountDown
      if (localCountDown) {
        //当前时间大于本地倒计时还是小于本地倒计时
        let dateNow = Date.parse(new Date());
        if (dateNow >= localCountDown) {
          this.isCountDownShow = false;
        } else {
          this.countDown = (localCountDown - dateNow) / 1000;
          this.isCountDownShow = true;
          this.calculationCountDown(localCountDown);
        }
      } else {
        //无localCountDown，没有在倒计时
        this.isCountDownShow = false;
      }
    },
    //计算出当前时间距离本地存储的倒计时还有多少秒
    calculationCountDown(localCountDown) {
      clearInterval(countDown);
      let countDown = setInterval(() => {
        let dateNow = Date.parse(new Date());
        if (localCountDown - dateNow > 999) {
          this.countDown = (localCountDown - dateNow) / 1000;
          this.isCountDownShow = true;
        } else {
          this.$emit("countDownOver");
          clearInterval(countDown);
          localStorage.removeItem(this.localName);
          this.isCountDownShow = false;
        }
      }, 1000);
    },
  },
};
</script>

<style scoped lang="scss">
@import "./code.scss";
</style>